import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '@clerk/clerk-react'
import { apiService } from '@/services/api'

interface TrackCTAOptions {
  componentName: string
  action?: 'click' | 'view' | 'hover'
  metadata?: Record<string, unknown>
}

/**
 * Hook for tracking upgrade CTA interactions for growth analytics.
 * Tracks when users interact with upgrade prompts throughout the app.
 */
export function useTrackUpgradeCTA() {
  const { userId, isSignedIn } = useAuth()
  const location = useLocation()

  const trackCTA = useCallback(
    async (options: TrackCTAOptions) => {
      // Only track for authenticated users
      if (!isSignedIn || !userId) return

      const { componentName, action = 'click', metadata = {} } = options

      try {
        await apiService.trackUpgradeCTA({
          userId,
          componentName,
          action,
          pagePath: location.pathname,
          metadata
        })
      } catch (error) {
        // Silently fail - tracking should never block user flow
        console.error('[useTrackUpgradeCTA] Failed to track CTA:', error)
      }
    },
    [isSignedIn, userId, location.pathname]
  )

  return { trackCTA }
}

export default useTrackUpgradeCTA
